/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable import/no-cycle */
/* eslint-disable react/jsx-no-constructed-context-values */
import React, { createContext, useEffect, useState } from 'react';
import { authStore, logoutSuccess } from '@store/slices/authSlice';
import { Modal } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { ANALYTIC_LIST_MODE } from '@common/constant/mode';
import { fabAccessLogApi } from '@services/fabAccessLogApi';
import jwt_decode from 'jwt-decode';
import AnalyticList from './Components/AnalyticList';
import AnalyticDetail from './Components/AnalyticDetail';

export const AnalyticContext = createContext();

function ManageAnalytics() {
  const { token } = useSelector(authStore);
  const tokenData = token && jwt_decode(token);
  const expTime = new Date(tokenData?.exp * 1000);
  const initTime = new Date(tokenData?.iat * 1000);
  const timeOut = expTime?.getTime() - initTime?.getTime();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [isActive, setIsActive] = useState(true);
  const [monthOptions, setMonthOptions] = useState([]);
  const [filterOptions, setFilterOptions] = useState({});
  const [mode, setMode] = useState(ANALYTIC_LIST_MODE);

  useEffect(() => {
    Promise.all([
      fabAccessLogApi.getMonthTree(),
      fabAccessLogApi.getFilterOptions(),
    ]).then((responses) => {
      const [monthFilter, optionFilter] = responses;
      setMonthOptions(monthFilter.data?.data || []);
      setFilterOptions(optionFilter.data || {});
    });
  }, []);

  const handleOk = () => {
    dispatch(logoutSuccess());
  };

  const handleCancel = () => {
    dispatch(logoutSuccess());
  };

  useEffect(() => {
    let timeoutId;

    const resetTimeout = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => setIsActive(false), timeOut);
    };

    const onActivity = () => resetTimeout();

    document.addEventListener('mousemove', onActivity);
    document.addEventListener('keydown', onActivity);

    resetTimeout();

    return () => {
      document.removeEventListener('mousemove', onActivity);
      document.removeEventListener('keydown', onActivity);
      clearTimeout(timeoutId);
    };
  }, []);

  return (
    <>
      <div>
        <Modal
          className="modal-timeout"
          okText="はい"
          open={!isActive}
          onOk={handleOk}
          onCancel={handleCancel}
        >
          <p className="text-center">タイムアウトしました。</p>
          <p className="text-center">再度ログインしてください。</p>
        </Modal>
      </div>

      <AnalyticContext.Provider
        value={{
          loading,
          setLoading,
          mode,
          setMode,
          monthOptions,
          filterOptions,
        }}
      >
        <div className="display-flex flex-column pl-100 full-height pr-100 pb-100 color-page">
          {mode === ANALYTIC_LIST_MODE ? <AnalyticList /> : <AnalyticDetail />}
        </div>
      </AnalyticContext.Provider>
    </>
  );
}

ManageAnalytics.propTypes = {};

export default ManageAnalytics;
